// eslint-disable-next-line no-restricted-imports
import {
  ActivityDto_Input,
  Query_LegalClientController_GetById_Activity_Activity,
} from 'api/generated/graphql';
import { LegalClientSaveActivityParam } from 'api/types/params';

export const parseLegalClientSaveActivityParam = (
  data: LegalClientSaveActivityParam
): ActivityDto_Input => ({
  activity:
    Query_LegalClientController_GetById_Activity_Activity[data.activity],
  isLargeEnterprise: data.isLargeEnterprise,
  isNominalHolder: data.isNominalHolder,
  isSubAccountRequiredForNominalHolding: data.requiresNominalHoldingSubaccount,
  otherActivity: data.otherActivity,
});
